module.exports = __webpack_public_path__ + "img/SketchPng366ac14790b4150fd776c74ea548eeef4dacbdb3fa3d14c87c634929228e7e23.05662a71.png";